<template>
  <Card v-if="loaded" :padding="0">
    <p slot="title">Новости</p>
    <a slot="extra" v-on:click="handleAdd">Добавить</a>
    <Modal
      :mask-closable="false"
      title="Новости"
      v-model="modal"
      :loading="saving"
      v-on:on-ok="handleSave"
      v-on:on-visible-change="handleVisibleChange"
      :ok-text="!!percentage ? `${percentage}%` : 'Сохранить'"
    >
      <Form v-if="modal" ref="form" :model="model" :rules="rules">
        <FormItem label="Наименование" prop="name">
          <Input v-model="model.name"/>
        </FormItem>
        <FormItem label="Описание" prop="description">
          <Input v-model="model.description" type="textarea" :autosize="{minRows: 3}"/>
        </FormItem>
        <FormItem label="Фотографии" prop="photos">
          <Upload
            v-model="model.photos"
            :max="5242880"
            unit="5 Мб."
            multiple
            accept=".jpg, .jpeg, .png"
          />
        </FormItem>
      </Form>
    </Modal>

    <div class="search-container">
      <Input search enter-button placeholder="Поиск" v-on:on-search="handleSearch"/>
    </div>
    <div>
      <div class="element" v-for="(element, index) in elements" :key="element.id">
        <div class="info">
          <p>
            <b>{{ element.name }}</b>
          </p>
          <p>{{ element.description }}</p>
          <div class="photos">
            <a
              v-for="(item, index) in element.photos"
              :key="`item ${index}`"
              target="_blank"
              rel="noopener noreferrer"
              :href="item.url"
            >
              <img :src="item.url">
            </a>
          </div>
        </div>
        <div class="icons-container">
          <Icon
            class="icon"
            type="md-create"
            size="20"
            v-on:click="() => handleEdit(element, index)"
          />
          <Icon
            class="icon"
            type="md-trash"
            size="20"
            v-on:click="() => handleDelete(element, index)"
          />
        </div>
      </div>
    </div>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";

import Upload from "../components/Upload";

import storage from "../plugins/storage";

export default {
  components: { Upload },
  data() {
    return {
      id: null,
      institution: null,
      loaded: false,
      modal: false,
      percentage: null,
      saving: true,
      model: {
        name: "",
        description: "",
        photos: []
      },
      rules: {
        name: [{ required: true, message: " ", pattern: /([^\s])/ }],
        description: [{ required: true, message: " ", pattern: /([^\s])/ }],
        photos: [{ required: true, message: " ", pattern: /([^\s])/ }]
      },
      data: [],
      elements: []
    };
  },
  async mounted() {
    const email = firebase.auth().currentUser.email;

    const ref = firebase
      .database()
      .ref(`institutions`)
      .orderByChild("admin")
      .equalTo(email);
    const snapshot = await ref.once("value");
    const array = [];

    snapshot.forEach(childSnapshot => {
      const element = childSnapshot.val();
      element.id = childSnapshot.key;
      array.push(element);
    });

    if (array.length > 0) {
      const institution = array[0];

      if (!institution.active) {
        await firebase.auth().signOut();

        this.$router.push("/auth");
      }

      this.institution = institution.id;

      try {
        const ref = firebase.database().ref(`news/${this.institution}`);
        const snapshot = await ref.once("value");
        const array = [];

        snapshot.forEach(childSnapshot => {
          const element = childSnapshot.val();
          element.id = childSnapshot.key;
          array.push(element);
        });

        this.data = array;
        this.elements = array;
      } catch (error) {}
    }

    this.loaded = true;
  },
  methods: {
    handleSearch(value) {
      const target = value.toLowerCase();

      this.elements = this.data.filter(e => {
        const name = e.name.toLowerCase();

        return name.startsWith(target);
      });
    },
    handleAdd() {
      this.modal = true;
    },
    handleDocumentAdd() {
      if (!this.model.documents) this.model.documents = [];

      this.model.documents.push({ title: null });
    },
    handleDocumentDelete(index) {
      this.$Modal.confirm({
        title: "Удаление",
        content: "Вы уверены, что хотите удалить?",
        onOk: () => this.model.documents.splice(index, 1)
      });
    },
    async handleDelete(item, index) {
      this.$Modal.confirm({
        title: "Удаление",
        content: "Вы уверены, что хотите удалить?",
        loading: true,
        onOk: async () => {
          const path = `news/${this.institution}/${item.id}`;
          await firebase
            .database()
            .ref(path)
            .remove();

          this.elements.splice(index, 1);

          this.$Modal.remove();
        }
      });
    },
    handleEdit(item, index) {
      this.id = item.id;

      this.model = {
        name: item.name,
        description: item.description,
        photos: item.photos
      };

      this.modal = true;
    },
    handleVisibleChange(value) {
      if (!value) {
        setTimeout(() => {
          this.$refs.form.resetFields();
          this.model.documents = [];
        }, 300);
      }
    },
    async handleSave() {
      const valid = await new Promise(resolve =>
        this.$refs.form.validate(valid => resolve(valid))
      );

      if (!valid) {
        this.$Message.error("Необходимо заполнить поля");
        this.saving = false;
        await this.$nextTick();
        this.saving = true;
        return;
      }

      await this.save();
    },
    async save() {
      try {
        const ref = !!this.id
          ? firebase.database().ref(`news/${this.institution}/${this.id}`)
          : firebase
              .database()
              .ref(`news/${this.institution}`)
              .push();

        this.model.photos = await storage.upload(
          this.model.photos,
          `news/${ref.key}/`,
          percentage => (this.percentage = percentage)
        );

        const data = {
          name: this.model.name,
          description: this.model.description,
          photos: this.model.photos
        };

        await ref.set(data);

        data.id = ref.key;

        if (this.id) {
          const index = this.elements.findIndex(e => e.id === this.id);
          this.$set(this.elements, index, data);
          this.id = null;
        } else {
          this.elements.push(data);
        }

        this.$Message.success("Успешно сохранено");

        this.modal = false;
      } catch (error) {
        console.log(error);

        this.$Message.error("Ошибка");

        this.saving = false;
        await this.$nextTick();
        this.saving = true;
      }
    }
  }
};
</script>

<style scoped>
.root {
  width: 100%;
  height: 100%;
}
.element:first-child {
  padding-top: 0;
}
.element {
  padding: 16px;
  border-bottom: 1px solid #e8eaec;
}
.element {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icons-container {
  margin-left: 8px;
  min-width: 56px;
}
.info {
  max-width: calc(100% - 64px);
}
.icon {
  cursor: pointer;
  margin: 4px;
}
.inline-block {
  width: 100%;
  display: inline-block;
}
.deletable-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.trash {
  cursor: pointer;
  padding-left: 10px;
  padding-right: 4px;
}
.search-container {
  padding: 16px;
}

.photos {
  display: flex;
  overflow: auto;
  max-width: 100%;
}
.photos img:first-child {
  margin-left: 0;
}
.photos img {
  margin: 8px;
  width: 100px;
  height: 100px;
  border-radius: 4px;
}
</style>